<template>
    <div class="send-address-list">
        <div class="send-address-list-box">
            <cus-field
                    type="search"
                    wrap-background="#fff"
                    input-background="#F1F1F1"
                    placeholder="请输入姓名/电话/地址"
                    @input="handleSearchInput"
                    v-model="params.params.query"
            ></cus-field>
            <van-list class="address-list__box body-padding" v-model="loading" :finished="finished" @load="getList"
                      finished-text="没有更多了"
                      :error.sync="error" error-text="请求失败，点击重新加载">
                <address-card
                        v-for="(item, index) in list"
                        :key="item.id"
                        v-model="list[index]"
                        @on-change="handleAddressChange(index)"
                        @on-pack-click="handlePackClick(index)"
                        @on-time-click="handleTimeClick(index)"
                        @on-need-cart-change="handleNeedCartChange($event, index)"
                        @on-edit="handleEditClick"
                        @on-del="handleDelClick"
                        @on-default="handleSetDefaultClick"
                ></address-card>
            </van-list>
        </div>
        <div class="body-padding">
            <div class="btn-box " :style="{ height:  '3.68rem', paddingTop: top + 'rem' }">
                <van-button to="/sendAddress/add" class="btn" round type="warning">新增寄件人</van-button>
                <van-button class="btn" round type="warning" @click="handleAddressConfirm">确认</van-button>
            </div>
        </div>

        <!-- 包装弹出 -->
        <van-action-sheet cancel-text="清空" v-model="packShow" :actions="packDict" @select="handlePackChange"
                          @cancel="handlePackEmpty"></van-action-sheet>

        <!-- 时间选择器 -->
        <van-popup position="bottom" v-model="timeShow">
            <!--<van-picker
                ref="timePicker"
                show-toolbar
                cancel-button-text="清空"
                @confirm="handleTimeConfirm"
                :columns="timeColumns"
                @change="handleTimeChange"
                @cancel="handleTimeEmpty"
            ></van-picker>-->
            <van-tree-select
                    :items="timePickerItems"
                    :main-active-index="timePickerOptions.mainActive"
                    :active-id="timePickerOptions.activeId"
                    max="1"
                    @navclick="handleTimePickerNav"
                    @itemclick="handleTimePickerItem"
            ></van-tree-select>
        </van-popup>
    </div>
</template>

<script>
    import {mapState} from 'vuex';

    export default {
        name: 'SendAddressList',
        data() {
            return {
                timePickerItems: [],
                timePickerOptions: {
                    mainActive: 0,
                    activeId: ''
                },
                inputFocus: false,
                packShow: false,
                timeShow: false,
                packDict: [],
                columns: {},
                timeColumns: [],
                index: null,
                loading: false,
                finished: false,
                error: false,
                params: {
                    params: {
                        addressType: 1,
                        query: ''
                    },
                    page: {
                        pageNum: 1,
                        pageSize: 10
                    }
                },
                // check: [...this.$store.state.sendList],
                list: [],
                searchTimeObj: null
            };
        },
        computed: {
            ...mapState({
                check: state => state.sendList,
                height: state => state.height,
                top: state => state.top
            })
        },
        watch: {
            $route(to, from) {
                this.$store.commit("setPath", "null")
            },
        },
        components: {
            AddressCard: () => import('./components/sendAddressCard')
        },
        mounted() {
            this.formatTimeSelect()
            let params = {
                params: 'PACK_NAME_TYPE'
            };
            this.$axios.post('/dict/info', params).then(res => {
                if (res.data.code === 200) {
                    res.data.data.forEach(val => {
                        val.name = val.dictName;
                    });
                    this.packDict = res.data.data;
                }
            });
        },
        methods: {
            PrefixInteger(num, length) {
                return ("0000000000000000" + num).substr(-length);
            },
            /**
             * @desc 格式化时间选择数据
             * @author 郑传俊
             */
            formatTimeSelect() {
                const items = [
                    {
                        text: '今天', id: '今天', children: []
                    },
                    {text: '明天', id: '明天', children: []}
                    /*{ text: '后天', id: '后天', children: [] }*/
                ];
                const now = new Date();
                const currentHour = now.getHours();
                if (currentHour >= 9) {
                    items[0].children.push({text: '一小时内', id: '一小时内'})
                }else {
                    items[0].children.push({text: '09:00-11:00', id: '09:00-11:00'})
                }
                for (let i = currentHour + 1; i < 24; i += 2) {
                    if (i + 2 > 24) {
                        items[0].children.push({
                            text: `${this.PrefixInteger(i, 2)}:00-24:00`,
                            id: `${this.PrefixInteger(i, 2)}:00-24:00`
                        });
                        break;
                    }
                    if(i>=9){
                        items[0].children.push({
                            text: `${this.PrefixInteger(i, 2)}:00-${i + 2}:00`,
                            id: `${this.PrefixInteger(i, 2)}:00-${i + 2}:00`
                        })
                    }
                }
                for (let i = 1; i < 24; i += 2) {
                    if (i >= 9 && i + 2 < 24) {
                        const index = i >= 10 ? i : '0' + i;
                        const index2 = i + 2 >= 10 ? i + 2 : '0' + (i + 2);
                        items[1].children.push({
                            text: `${index}:00-${index2}:00`,
                            id: `${index}:00-${index2}:00`
                        });
                    } else if (i + 2 > 24) {
                        const index = i >= 10 ? i : '0' + i;
                        const index2 = i + 1 >= 10 ? i + 1 : '0' + (i + 1);
                        items[1].children.push({
                            text: `${index}:00-${index2}:00`,
                            id: `${index}:00-${index2}:00`
                        });
                    }
                }
                this.timePickerItems = items
                this.timePickerOptions.activeId = currentHour>=9?'一小时内':'09:00-11:00'
            },
            handleTimePickerNav(index) {
                this.timePickerOptions.mainActive = index
            },
            handleTimePickerItem(data) {
                this.timePickerOptions.activeId = data.id
                this.timeShow = false
                this.$set(this.list[this.index], 'planDeliveryDate', this.timePickerItems[this.timePickerOptions.mainActive].text + this.timePickerOptions.activeId);
                if (this.list[this.index].check) {
                    this.check.forEach((val, i) => {
                        if (val.id === this.list[this.index].id) {
                            this.$set(this.check[i], 'planDeliveryDate', this.timePickerOptions.activeId);
                        }
                    });
                }
            },
            handlePackClick(i) {
                this.index = i;
                this.packShow = true;
            },
            handleTimeClick(i) {
                this.index = i;
                this.setTime();
                this.timeShow = true;
            },
            handlePackEmpty() {
                this.$set(this.list[this.index], 'packId', '');
                this.$set(this.list[this.index], 'packName', '');
                if (this.list[this.index].check) {
                    this.check.forEach((val, i) => {
                        if (val.id === this.list[this.index].id) {
                            this.$set(this.check[i], 'packId', '');
                            this.$set(this.check[i], 'packName', '');
                        }
                    });
                }
            },
            handlePackChange({dictValue, dictName}) {
                this.$set(this.list[this.index], 'packId', dictValue);
                this.$set(this.list[this.index], 'packName', dictName);
                if (this.list[this.index].check) {
                    this.check.forEach((val, i) => {
                        if (val.id === this.list[this.index].id) {
                            this.$set(this.check[i], 'packId', dictValue);
                            this.$set(this.check[i], 'packName', dictName);
                        }
                    });
                }
                this.packShow = false;
            },
            setTime() {
                let hour = new Date().getHours();
                let minute = new Date().getMinutes();
                let hours = [];
                let minutes = [];
                let h1 = hour;
                let m1 = minute;
                for (let i = hour; i <= 23; i++) {
                    hours.push(h1 < 10 ? '0' + h1 + '时' : h1 + '时');
                    h1++;
                }
                let hours1 = [];
                for (let i = 0; i <= 23; i++) {
                    hours1.push(i < 10 ? '0' + i + '时' : i + '时');
                }
                for (let i = minute; i <= 59; i++) {
                    minutes.push(m1 < 10 ? '0' + m1 + '分' : m1 + '分');
                    m1++;
                }
                let minutes1 = [];
                for (let i = 0; i <= 59; i++) {
                    minutes1.push(i < 10 ? '0' + i + '分' : i + '分');
                }

                let columns = {};
                columns.今天 = {};
                columns.明天 = {};
                columns.后天 = {};
                for (let i = 0; i < hours.length; i++) {
                    if (i === 0) {
                        columns.今天[hours[i]] = minutes;
                    } else {
                        columns.今天[hours[i]] = minutes1;
                    }
                }
                for (let i = 0; i < hours1.length; i++) {
                    columns.明天[hours1[i]] = minutes1;
                    columns.后天[hours1[i]] = minutes1;
                }
                this.columns = columns;
                this.timeColumns = [
                    {
                        values: Object.keys(columns),
                        className: 'column1'
                    },
                    {
                        values: Object.keys(columns.今天),
                        className: 'column2',
                        defaultIndex: 0
                    },
                    {
                        values: columns.今天[hours[0]],
                        className: 'column3',
                        defaultIndex: 0
                    }
                ];
            },
            handleTimeChange(picker, values, i) {
                if (i === 0) {
                    picker.setColumnValues(1, Object.keys(this.columns[values[0]]));
                    picker.setColumnValues(2, this.columns[values[0]][this.$refs.timePicker.getColumnValue(1)]);
                }
                if (i === 1) {
                    picker.setColumnValues(2, this.columns[values[0]][values[1]]);
                }
            },
            handleTimeEmpty() {
                this.$set(this.list[this.index], 'planDeliveryDate', '');
                if (this.list[this.index].check) {
                    this.check.forEach((val, i) => {
                        if (val.id === this.list[this.index].id) {
                            this.$set(this.check[i], 'planDeliveryDate', '');
                        }
                    });
                }
                this.timeShow = false;
            },
            handleTimeConfirm(value) {
                let timeVal = value[0] + ' ' + value[1].substring(0, value[1].length - 1) + ':' + value[2].substring(0, value[2].length - 1);
                this.$set(this.list[this.index], 'planDeliveryDate', timeVal);
                if (this.list[this.index].check) {
                    this.check.forEach((val, i) => {
                        if (val.id === this.list[this.index].id) {
                            this.$set(this.check[i], 'planDeliveryDate', timeVal);
                        }
                    });
                }
                this.timeShow = false;
            },
            handleNeedCartChange(needWheelbarrow, index) {
                let item = this.list[index];
                this.$set(this.list[index], 'needWheelbarrow', needWheelbarrow);
                if (item.check) {
                    this.check.forEach((val, i) => {
                        if (val.id === item.id) {
                            this.$set(this.check[i], 'needWheelbarrow', needWheelbarrow);
                        }
                    });
                }
            },
            handleAddressChange(index) {
                let item = this.list[index];
                if (item.check) {
                    item.check = false;
                    return;
                }
                this.$set(this.list[index], 'check', true);
                let arr = this.list.filter(val => val.id !== item.id && val.check);
                if (arr.length === 0) {
                    return;
                }
                let lat = arr[0].lat;
                let lng = arr[0].lng;
                let clothingCityId = arr[0].clothingCityId;
                let provinceName = arr[0].provinceName;
                let cityName = arr[0].cityName;
                let districtName = arr[0].districtName;
                let hasPoint = lat !== 0.0 && lng !== 0.0 && item.lat !== 0.0 && item.lng !== 0.0;
                if (hasPoint) {
                    let obj1 = {lat, lng};
                    let obj2 = {lat: item.lat, lng: item.lng};
                    if (this.radLat(obj1, obj2) <= 3) {
                        return;
                    }
                }

                let judgeClothingCity = clothingCityId !== '' && item.clothingCityId === clothingCityId;
                let judgeLocal = provinceName === item.provinceName && cityName === item.cityName && districtName === item.districtName;
                if (judgeClothingCity || judgeLocal) {
                    return;
                }
                this.$toast({
                    message: '寄件人地址不能跨区域！',
                    duration: 1000
                });
                item.check = false;
            },
            rad(lat) {
                return (lat * Math.PI) / 180;
            },
            radLat(obj1, obj2) {
                let lat1 = obj1.lat,
                    lng1 = obj1.lng,
                    lat2 = obj2.lat,
                    lng2 = obj2.lng;
                let a = this.rad(lat1) - this.rad(lat2);
                let b = this.rad(lng1) - this.rad(lng2);
                let s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) + Math.cos(this.rad(lat1)) * Math.cos(this.rad(lat2)) * Math.pow(Math.sin(b / 2), 2)));
                s = s * 6378.137;
                s = Math.round(s * 10000) / 10000;
                s = parseInt(s);
                return s;
            },
            handleEditClick(item) {
                // this.check.forEach(val => {
                //     this.list.forEach(value => {
                //         if (val.id === value.id) {
                //             Object.keys(value).forEach(key => {
                //                 this.$set(val, key, value[key]);
                //             });
                //         }
                //     });
                // });
                // this.$store.commit({
                //     type: "confirmSelect",
                //     t: '1',
                //     list: this.check
                // });
                let check = this.list.filter(val => val.check);
                this.$store.commit('confirmSend', check);
                this.$router.push('/sendAddress/modify/' + item.id);
            },
            handleDelClick(item) {
                this.$dialog
                    .confirm({
                        title: '温馨提示',
                        message: '是否确认删除该地址'
                    })
                    .then(() => {
                        let params = {
                            params: item.id
                        };
                        this.$axios.post('merchantConcat/removeAddress', params).then(() => {
                            if (item.check) {
                                this.$store.commit('uncheckSend', item);
                            }
                            this.list.splice(0, this.list.length);
                            this.params.page.pageNum = 1;
                            this.loading = true;
                            this.finished = false;
                            this.getList();
                        });
                    })
                    .catch(err => {
                        this.$toast({
                            message: err.data.msg,
                            duration: 1000
                        });
                    });
            },
            handleSetDefaultClick({id}) {
                this.list.forEach(item => {
                    item.addressDefault = 0
                })
                this.list.forEach(item => {
                    if (item.id == id) {
                        item.addressDefault = 1
                    }
                })
                let params = {
                    params: {
                        addressType: 1,
                        id: id
                    }
                };
                this.$axios.post('merchantConcat/setAddressDefault', params).then(res => {
                    if (res.data.code === 200) {
                        // this.loading = true;
                        // this.list.splice(0, this.list.length);
                        // this.finished = false;
                        // this.params.page.pageNum = 1;
                        // this.getList();
                    }
                });
            },
            getList() {
                this.$axios
                    .post('merchant/getPageAddressByType', this.params)
                    .then(res => {
                        let data = res.data.data;
                        if (!Array.isArray(data.list)) {
                            this.finished = true;
                            return;
                        }
                        let checkList = JSON.parse(JSON.stringify(this.check));
                        if (checkList.length !== 0) {
                            checkList.forEach((checkItem, checkI) => {
                                checkItem.check = true;
                                data.list.forEach((item, i) => {
                                    if (checkItem.id === item.id) {
                                        item.check = true;
                                        item.goodsNumber = checkItem.goodsNumber;
                                        item.needWheelbarrow = checkItem.needWheelbarrow;
                                        checkList[checkI] = Object.assign({}, checkItem, item);
                                        data.list.splice(i, 1);
                                    }
                                });
                                this.list.forEach((item, i) => {
                                    if (checkItem.id === item.id) {
                                        this.list.splice(i, 1);
                                    }
                                });
                            });
                        }
                        this.list = JSON.parse(JSON.stringify([...checkList, ...this.list, ...data.list]));
                        this.params.page.pageNum++;
                        this.finished = !data.hasNextPage;
                        //this.finished = true
                    })
                    .catch(err => {
                        this.error = true;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            handleSearchInput() {
                clearTimeout(this.searchTimeObj);
                let query = this.params.params.query;
                let isNumber = !isNaN(query);
                if (query.length !== 0 && ((isNumber && query.length < 4) || (!isNumber && query.length < 1))) return;
                this.searchTimeObj = setTimeout(() => {
                    this.list.splice(0, this.list.length);
                    this.params.page.pageNum = 1;
                    this.loading = true;
                    this.finished = false;
                    this.getList();
                }, 500);
            },
            handleAddressConfirm() {
                let check = this.list.filter(val => val.check);
                if (check.length === 0) {
                    this.$toast({
                        message: '请至少选择一个寄件人!',
                        duration: 1000
                    });
                    return;
                }
                this.$store.commit('confirmSend', check);
                this.$router.go(-1)
            }
        }
    };
</script>

<style scoped lang="scss">
    .send-address-list {
        padding: 0;
        display: flex;
        flex-direction: column;
        overflow: hidden;

        .send-address-list-box {
            overflow-y: scroll;
            -webkit-overflow-scrolling: touch;
            box-sizing: border-box;
            flex: 1;
            /*padding: 0;*/
            /*display: flex;*/
            /*flex-direction: column;*/
            /*overflow: hidden;*/
            /*height: calc(100% - 3.84rem);*/
            /*padding-bottom: 3rem;*/
            /*overflow-y: scroll;*/
            /*box-sizing: border-box;*/
        }

        .address-list__box {
            box-sizing: border-box;
            overflow-y: scroll;
            -webkit-overflow-scrolling: touch;
            flex: 1;
        }
    }

    .search-box {
        padding: 0.21rem;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #fff;
    }

    .btn-box {
        height: 3.68rem;
        position: relative;
        background: #fff;
        border-top: 1px solid #e5e5e5;
        box-sizing: border-box;
        padding: 1.81rem 0.36rem 0;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        overflow: hidden;

        &:before {
            content: '专业市场拼包，单个地址免费提货 \00A0 \00A0 \00A0 每加 1个地址，收2元提货费30元封顶';
            text-indent: 0.45rem;
            width: 5.8rem;
            height: 0.8rem;
            text-align: center;
            position: absolute;
            top: 0.56rem;
            left: 0;
            right: 0;
            margin: auto;
            font-size: 0.32rem;
            color: #8f8f8f;
        }

        .btn {
            width: 4rem;
        }
    }

    .cus-field-search {
        height: 1.333333rem;
    }
</style>
